import { Dispatch } from 'redux';
import api from '../services/api';
import { TaskLogItem } from '../components/TaskLogs/Models';
import { handleError } from './dashboard';
import { format } from 'date-fns';
export class TaskLogsActionTypes {
  public static readonly IS_LOADING = 'TASK_LOGS_ARE_LOADING';
  public static readonly TASK_LOGS_FETCHED = 'TASK_LOGS_FETCHED';
  public static readonly TASK_LOGS_FETCH_FAILED = 'TASK_LOGS_FETCH_FAILED';
  public static readonly RESET = 'RESET_TASK_LOGS';
  public static readonly TOGGLE_TASK_LOGS = 'TOGGLE_TASK_LOGS';
  public static readonly CLOSE_TASK_LOGS = 'CLOSE_TASK_LOGS';
  public static readonly SET_IN_PROGRESS_TASK_LOG = 'SET_IN_PROGRESS_TASK_LOG';
}

type responseFileObject = {
  id: string;
  TaskName: string;
  ExecutionId: string;
  ScheduledTaskId: string;
  ClientId: string;
  Status: string;
  UserId: string;
  AdditionalData: any;
  createdAt: string;
  Duration: string;
};
const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word: any) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
const structurizeFiles = (
  data: Array<responseFileObject>
): Array<TaskLogItem> => {
  let results: Array<TaskLogItem> = [];

  if (data) {
    data.forEach((item: responseFileObject, i: number) => {
      results.push({
        taskName: toTitleCase(item.TaskName?.replaceAll('_', ' ')),
        executionId: item.ExecutionId,
        clientId: item.ClientId,
        status: item.Status,
        userId: item.UserId,
        user: item.AdditionalData?.user?.user ?? '-',
        additionalData: item.AdditionalData,
        scheduledTaskId: item.ScheduledTaskId,
        createdAt: format(new Date(item.createdAt), 'yyyy-MM-dd HH:mm'),
        duration: item.Duration,
      });
    });
  }

  return results;
};

export const fetchTaskLogs = () => (dispatch: Dispatch) => {
  dispatch({
    type: TaskLogsActionTypes.IS_LOADING,
    payload: true,
  });
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 1);
  const endDate = new Date();
  api
    .getSchedulerJobs(startDate, endDate)
    .then((res: any) => {
      let results = structurizeFiles(res.data);
      if (
        results[0] &&
        !JSON.stringify(results[0].status).includes('SUCCESS') &&
        !JSON.stringify(results[0].status).includes('ERROR')
      ) {
        dispatch({
          type: TaskLogsActionTypes.SET_IN_PROGRESS_TASK_LOG,
          payload: results[0],
          meta: {
            track: true,
          },
        });
      }
      dispatch({
        type: TaskLogsActionTypes.TASK_LOGS_FETCHED,
        payload: results,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      handleError(err, dispatch, {
        message: 'Task logs not fetched',
        type: 'info',
      });
      dispatch({
        type: TaskLogsActionTypes.TASK_LOGS_FETCH_FAILED,
        payload: true,
        meta: {
          track: true,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: TaskLogsActionTypes.IS_LOADING,
        payload: false,
      });
    });
};

export const toggleTaskLogs = () => (dispatch: Dispatch) => {
  dispatch({
    type: TaskLogsActionTypes.TOGGLE_TASK_LOGS,
    payload: null,
    meta: {
      track: true,
    },
  });
};

export const closeTaskLogs = () => (dispatch: Dispatch) => {
  dispatch({
    type: TaskLogsActionTypes.CLOSE_TASK_LOGS,
    payload: null,
    meta: {
      track: true,
    },
  });
};

export const checkTaskLogStatus =
  (taskLog: TaskLogItem) => (dispatch: Dispatch) => {
    api
      .getTaskExecutionStatus(taskLog.executionId)
      .then((res: any) => {
        if (
          res.data &&
          (JSON.stringify(res.data.Status).includes('SUCCESS') ||
            JSON.stringify(res.data.Status).includes('ERROR'))
        ) {
          dispatch({
            type: TaskLogsActionTypes.SET_IN_PROGRESS_TASK_LOG,
            payload: null,
            meta: {
              track: true,
            },
          });
          dispatch({
            type: 'SHOW_NOTIFICATIONS',
            payload: {
              message: `${taskLog.taskName} ${
                JSON.stringify(res.data.Status).includes('SUCCESS')
                  ? 'finished succesfully'
                  : 'has failed'
              }`,
              type: 'info',
            },
          });
          fetchTaskLogs()(dispatch);
        }
      })
      .catch((err) => {
        handleError(err, dispatch, {
          message: 'Task log status not fetched',
          type: 'info',
        });
        dispatch({
          type: TaskLogsActionTypes.SET_IN_PROGRESS_TASK_LOG,
          payload: null,
          meta: {
            track: true,
          },
        });
      });
  };
